import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import Joi from 'joi-browser';
import { parts } from '../../../utilities/parts';
import workerSafetyBasicInfoApi from '../../../services/workers/workerSafetyBasicInfo/WorkerSafetyBasicInfoApi';
import workerSafetyBasicInfoService from '../../../services/workers/workerSafetyBasicInfo/WorkerSafetyBasicInfoService';
import CcusMasterService from '../../../services/CcusMasters';
import SessionStorageService from '../../../services/utilities/SessionStorageService';

import { WorkerHeader } from '../header/WorkerHeader';
import WorkerSafetyBasicInfoForm from '../form/WorkerSafetyBasicInfoForm';
import Information from '../../modals/common/Information';
import Confirmation from '../../modals/common/Confirmation';
import ConfirmationSafetyDocItemDialog from '../dialog/ConfirmationSafetyDocItemDialog';
import { FetchCcusDescription } from '../../FetchCcusDescription';

import masterSlideLoader from '../../../utilities/masterSlideLoader';
import { messageUtility } from '../../../utilities/messageUtility';
import { validationByJoi } from '../../../utilities/commonValidation';
import {
  extractErrorMessage,
  getZendeskArticleUrl,
} from '../../../utilities/commonUtil';
import {
  deleteControlCode,
  isNullOrUndefinedOrEmptyStr,
} from '../../../utilities/stringUtil';
import {
  attachDocumentDeleteState,
  attachDocumentWorkerCodesRead,
  attachDocumentWorkerUploadState,
  attachDocumentWorkerDownload,
  attachDocumentFilesCheck,
} from '../../../utilities/attachDocumentUtil';
import { getTextBloodTypeId } from '../../../utilities/constantsUtil';
import { convertDate } from '../../../utilities/validateDateUtil';
import EventMg, { EventType } from '../../../utilities/EventManager';

import {
  ENV_VARS,
  WORKER_TAB,
  WORKER_RESIDENCE_STATUS_CODES,
  DATE_TIME_FORMAT,
  WORKER_PAGE_STATUS,
  DIALOG_STATUS,
  DISPLAY_FLAG,
  SAFETY_DOC_ITEM_VALIDATE,
  NATIONALITY_INFO,
  ATTACH_DOCUMENT_TYPE_WORKER,
  BLOOD_TYPE,
  BLOOD_TYPE_RH,
  ZENDESK_LINK_IDS,
  ZENDESK_URL_GUIDE,
} from '../../../utilities/constants';

import styles from '../../../styles/componentStyle/workerForm/workerForm.scss';
import { MoveLeftIcon } from '../../icons/MoveLeftIcon';

/**
 * 作業員一覧 労務安全基本情報タブ ページ
 * @props {string}companyId:会社ID
 * @props {string}workerId:作業員ID
 * @props {object}pageStatus:ページ情報 (新規・詳細・編集)
 * @props {Boolean}isAlreadyCcusConnect:CCUSと連携しているか？
 * @props {Boolean}isAgencyRegister:代理ログインか？
 * @props {string}linkedToCcusDate:CCUSと連携した時間
 * @props {Boolean}isOverSixteen:16歳以上か？
 * @props {function}callFetchCcusWorkersData:CCUS情報取得処理
 */
export class WorkerSafetyBasicInfo extends React.Component {
  defaultWorkerSafetyBasicInfo = {
    // 血液型
    blood_type: null, // ABO血液型
    blood_type_rh: null, // Rh血液型

    // 国籍情報
    foreigner_flag: null, // 国籍
    nationality: null, // 国名
    resident_status: 0, // 在留資格コード
    resident_status_name: null, // 在留資格名
    staying_period_expiration_date: null, // 在留期間満了日

    // 経験開始・雇入年月日
    experience_start_date: null, // 経験開始年月日
    employer_in_date: null, // 雇入年月日
    blank_months: null, // ブランク期間(月)

    // 教育
    education: null, // 雇入時教育受講有無
    employment_education_date: null, // 雇入時教育年月日
    ability_improving_education_code: null, // 能力向上教育受講有無
    recurrent_protection_education_code: null, // 危険有害業務_再発防止教育受講有無

    // 住所・連絡先
    postal_code: null, // 郵便番号
    prefectures: null, // 都道府県
    city_name: null, // 市区町村
    address1: null, // 住所1
    address2: null, // 住所2
    tel: null, // 電話番号
    fax: null, // FAX
    email: null, // メールアドレス
  };

  defaultCcusInfo = {
    blood_type: null,

    foreigner_flag: null,
    nationality: null,
    resident_status_code: null,
    resident_status_name: null,
    staying_period_expiration_date: null,
    experience_start_date: null,

    resident_cd: null,
    employer_in_date: null,

    postal_code: null,
    prefectures: null,
    city_name: null,
    address1: null,
    address2: null,
    tel: null,
    fax: null,
    email: null,
  };

  state = {
    header: {
      // 作業員基本情報ヘッダー用プロパティ
      LinkButtonObject: {}, // 作業員一覧ページに戻るリンク (内容はbuttonObject)
      buttonObject: {}, // ボタン内容 (内容はbuttonObject)
    },
    headerButtonObject: {
      // ヘッダーで必要なモデル (詳細はWorkerHeader.jsxを参照)
      label: data.defaultButton.label, // テキスト
      className: data.defaultButton.className, // クラス名
      onClick: null, // 処理
    },

    workerSafetyBasicInfo: { ...this.defaultWorkerSafetyBasicInfo },
    ccusInfo: { ...this.defaultCcusInfo },
    validErrorMessage: {}, // バリデーションエラーメッセージ
    comboBoxList: {},
    attachDocumentCodes_Certificate: [], // 健康保険 保険証 選択項目
    attachDocuments_Certificate: [], // 健康保険 保険証 内容

    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示用ステータス
    confirmationModalSafetyDocItem: {
      // 安全書類項目用バリデート
      errorPropertyList: [],
    },
    informationModal: {
      // インフォメーションモーダル用プロパティ (ボタン1つ)
      message: null, // モーダルダイアログのメッセージ
    },
    roanToChoseiFlg: false, // 労安からの遷移先が直接「作業員詳細」か、黒メニュー「作業員一覧」経由かを区別するフラグ
  };

  events = {};

  constructor(props) {
    super(props);

    this.updatingFlag = true; // 多重更新防止Flag

    if (_.isUndefined(props.pageStatus)) {
      throw new Error('WorkerSafetyBasicInfo.jsx constructor props.pageStatus');
    } else {
      if (
        !(
          props.pageStatus === WORKER_PAGE_STATUS.CONFIRM ||
          props.pageStatus === WORKER_PAGE_STATUS.EDIT
        )
      ) {
        throw new Error(
          'WorkerSafetyBasicInfo.jsx constructor props.pageStatus'
        );
      }
    }
    if (_.isUndefined(props.workerId)) {
      throw new Error('WorkerSafetyBasicInfo.jsx constructor props.workerId');
    }
    if (_.isUndefined(props.companyId)) {
      throw new Error('WorkerSafetyBasicInfo.jsx constructor props.companyId');
    }

    this.events.validate = this.validate.bind(this);
    this.events.setCCUSValuesDetail = this.setCCUSValuesDetail.bind(this);
    this.events.setCCUSValuesDetailAll = this.setCCUSValuesDetailAll.bind(this);
    this.events.setWorkerSafetyBasicInfoResidentStatus = this.setWorkerSafetyBasicInfoResidentStatus.bind(
      this
    );
    this.events.setValueWorkerSafetyBasicInfo = this.setValueWorkerSafetyBasicInfo.bind(
      this
    );
    this.events.uploadFile = this.uploadFile.bind(this);
    this.events.download = this.download.bind(this);
    this.events.deleteFile = this.deleteFile.bind(this);
    this.events.showCcusInfoTranscriptionAgreementDialog = this.showCcusInfoTranscriptionAgreementDialog.bind(
      this
    );
    this.state.roanToChoseiFlg = props.roanToChoseiFlg;

    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createConfirmPageHeaderButton(this.state);
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createEditPageHeaderButton(this.state);
        break;
      default:
        break;
    }

    this.validationColumns = [
      'nationality',
      'postal_code',
      'prefectures',
      'city_name',
      'address1',
      'address2',
      'tel',
      'fax',
      'email',
      'blank_months',
      'employment_education_date',
      'resident_status',
      'staying_period_expiration_date',
      'experience_start_date',
      'employer_in_date',
      'employment_education_date',
    ];
  }

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  async componentDidMount() {
    const state = _.cloneDeep(this.state);

    const matchFormatPostalCodeHyphen = value => {
      return value.match(/^\d{3}-\d{4}$/) ? true : false;
    };

    // 編集モード時のみComboBoxの選択内容を取得する
    if (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID) {
      const params = { display_flag: DISPLAY_FLAG.use.id };
      await CcusMasterService.residentStatus(params).then(response => {
        if (response.result === true) {
          const residentStatuses = response.data.entities.resident_statuses;
          // 「特定活動」をプルダウンの最初に表示させる（未設定の後）
          const sortedStatuses = residentStatuses.sort((a, b) => {
            if (
              a.resident_status_code ===
              WORKER_RESIDENCE_STATUS_CODES.UNASSIGNED
            ) {
              return -1; // 未設定
            } else if (
              b.resident_status_code ===
              WORKER_RESIDENCE_STATUS_CODES.UNASSIGNED
            ) {
              return 1;
            } else if (
              a.resident_status_code ===
              WORKER_RESIDENCE_STATUS_CODES.SPECIFIC_ACTIVITY
            ) {
              return -1; // 特定活動
            } else if (
              b.resident_status_code ===
              WORKER_RESIDENCE_STATUS_CODES.SPECIFIC_ACTIVITY
            ) {
              return 1;
            } else {
              return a.resident_status_code - b.resident_status_code;
            }
          });
          state.comboBoxList.residentStatus = sortedStatuses;
        }
      });
    }

    // 労務安全項目情報（労務安全基本情報）を取得する
    await workerSafetyBasicInfoApi
      .fetchWorkerSafetyBasicInfo(this.props.companyId, this.props.workerId)
      .then(response => {
        if (response.result) {
          // 労務安全基本情報
          const workerSafetyBasicInfo = response.data.entities.worker_details;

          // blood_type_rh だけ数値なので文字列変換する
          workerSafetyBasicInfo.blood_type_rh = parts.isInteger(
            workerSafetyBasicInfo.blood_type_rh
          )
            ? workerSafetyBasicInfo.blood_type_rh.toString()
            : workerSafetyBasicInfo.blood_type_rh;

          // 指定のキーが存在するかどうかを確認している
          const checkKeys = Object.keys(this.defaultWorkerSafetyBasicInfo);
          if (!parts.inProperty(workerSafetyBasicInfo, checkKeys)) {
            throw new Error(
              'WorkerSafetyBasicInfo.jsx componentDidMount' +
                ' workerSafetyBasicInfoApi.fetchWorkerSafetyBasicInfo'
            );
          }
          state.workerSafetyBasicInfo = Object.assign(
            state.workerSafetyBasicInfo,
            workerSafetyBasicInfo
          );

          // // 編集画面の場合、雇入時教育受講有無等が未設定の場合初期値設定する
          // 現在対象外のためコメントアウトで残す
          // if (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID) {
          //   _.map(state.workerSafetyBasicInfo, (value, key) => {
          //     state.workerSafetyBasicInfo = this.setDefaultFormValues(
          //       key,
          //       value,
          //       state.workerSafetyBasicInfo
          //     );
          //   });
          // }

          // 労務安全基本情報 の CCUS 連携情報
          const ccus_info = response.data.entities.ccus_worker_details;
          // 郵便番号が正しい形ではない場合成形
          if (
            !_.isNull(ccus_info.postal_code) &&
            !matchFormatPostalCodeHyphen(ccus_info.postal_code)
          ) {
            ccus_info.postal_code = `${ccus_info.postal_code.slice(
              0,
              3
            )}-${ccus_info.postal_code.slice(3)}`;
          }
          ccus_info.resident_status_code =
            response.data.entities.resident_status.resident_status_code;
          ccus_info.resident_status_name =
            response.data.entities.resident_status.resident_status_name;
          if (!parts.inProperty(ccus_info, Object.keys(this.defaultCcusInfo))) {
            throw new Error(
              'WorkerSafetyBasicInfo.jsx componentDidMount ccus_info'
            );
          }
          state.ccusInfo = Object.assign(state.ccusInfo, ccus_info);

          if (!_.isArray(response.data.entities.worker_documents)) {
            throw new Error(
              'WorkerSafetyBasicInfo.jsx componentDidMount worker_documents'
            );
          }
          state.attachDocuments_Certificate =
            response.data.entities.worker_documents;
        } else {
          alert(response.message);
        }
      });

    // 添付ファイル情報 選択項目の小分類コード一覧を取得する
    await attachDocumentWorkerCodesRead(
      state,
      ['attachDocumentCodes_Certificate'],
      [ATTACH_DOCUMENT_TYPE_WORKER.CERTIFICATE]
    );

    // CCUSから情報を取得ボタンを押された後の処理
    if (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID) {
      EventMg.addEventListener(EventType.FETCH_CCUS_INFO, async () => {
        // CCUS情報の再取得
        await workerSafetyBasicInfoApi
          .fetchWorkerSafetyBasicInfo(this.props.companyId, this.props.workerId)
          .then(response => {
            if (response.result) {
              const state = _.cloneDeep(this.state);

              // 労務安全基本情報 の CCUS 連携情報
              const ccus_info = response.data.entities.ccus_worker_details;
              // 郵便番号が正しい形ではない場合成形
              if (
                !_.isNull(ccus_info.postal_code) &&
                !matchFormatPostalCodeHyphen(ccus_info.postal_code)
              ) {
                ccus_info.postal_code = `${ccus_info.postal_code.slice(
                  0,
                  3
                )}-${ccus_info.postal_code.slice(3)}`;
              }
              ccus_info.resident_status_code =
                response.data.entities.resident_status.resident_status_code;
              ccus_info.resident_status_name =
                response.data.entities.resident_status.resident_status_name;
              if (
                !parts.inProperty(ccus_info, Object.keys(this.defaultCcusInfo))
              ) {
                throw new Error(
                  'WorkerSafetyBasicInfo.jsx componentDidMount ccus_info'
                );
              }
              state.ccusInfo = Object.assign(state.ccusInfo, ccus_info);

              this.setState(state);
            }
          });
      });
    }

    this.setState(state, () => {
      this.updatingFlag = false; // 画面ロード後更新可能になる
      if (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID) {
        this.validate('resident_status'); // BLDE_V2-45018 画面表示時に在留資格を確認する
      }
    });
  }

  /**
   * React Component LifeCycle
   * コンポーネントがアンマウントされる時
   * */
  componentWillUnmount() {
    // アンマウントされる時にEventListenerを削除する
    EventMg.deleteEvent(EventType.FETCH_CCUS_INFO);
  }

  /**
   * =====================================================
   * ヘッダー周りの処理 - START
   * =====================================================
   */

  /**
   * buttonObjectを初期化する
   * @param {object} state: ステート
   * */
  clearButtonObject = state => {
    state.headerButtonObject.label = data.defaultButton.label;
    state.headerButtonObject.className = data.defaultButton.className;
    state.headerButtonObject.onClick = null;
    return state;
  };

  /**
   * 作業員一覧ページに戻るためのリンクを作成する
   * @param {object} state: ステート
   * */
  createObjectForMoveToWorkerList = state => {
    state.headerButtonObject.label = data.buttonLink.label;
    state.headerButtonObject.className = data.buttonLink.defaultClassName;
    state.headerButtonObject.onClick = this.handlerMoveToWorkerList.bind(this);
    state.header.LinkButtonObject.moveToWorkerList = _.cloneDeep(
      state.headerButtonObject
    );
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 詳細画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createConfirmPageHeaderButton = state => {
    // 編集ボタン作成
    state.headerButtonObject.label = data.header.confirm.button.edit.label;
    state.headerButtonObject.className =
      data.header.confirm.button.edit.className;
    state.headerButtonObject.onClick = this.moveToWorkerEdit.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);

    return state;
  };

  /**
   * 編集画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createEditPageHeaderButton = state => {
    // 編集をやめるボタン作成
    state.headerButtonObject.label = data.header.edit.button.cancel.label;
    state.headerButtonObject.className =
      data.header.edit.button.cancel.className;
    state.headerButtonObject.onClick = this.showCancelEditDialog.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);

    // 更新ボタン作成
    state.headerButtonObject.label = data.header.edit.button.update.label;
    state.headerButtonObject.className =
      data.header.edit.button.update.className;
    state.headerButtonObject.onClick = this.handlerUpdate;

    state.header.buttonObject.register = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 作業員一覧へ戻るリンクをクリックした時の処理
   * */
  handlerMoveToWorkerList = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showLeaveThisPageDialog();
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.moveToWorkerList();
        break;
      default:
        throw new Error('WorkerSafetyBasicInfo.jsx handlerMoveToWorkerList');
    }
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * 画面遷移周りの処理 - START
   * =====================================================
   */

  /**
   * 作業員一覧画面に遷移する
   */
  moveToWorkerList = () => {
    masterSlideLoader.show('Workers', { state: {} });
  };

  /**
   * 作業員詳細画面に遷移する
   */
  moveToWorkerConfirm = () => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }
    masterSlideLoader.show('WorkerConfirm', {
      state: {
        id: `${WORKER_TAB.WORKER_SAFETY_BASIC_INFO.TAB_NAME},${this.props.workerId}`,
      },
    });
  };

  /**
   * 作業員編集画面に遷移する
   */
  moveToWorkerEdit = () => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }
    masterSlideLoader.show('WorkerEdit', {
      state: {
        id: `${WORKER_TAB.WORKER_SAFETY_BASIC_INFO.TAB_NAME},${this.props.workerId}`,
      },
    });
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * ダイアログ周りの処理 - START
   * =====================================================
   */

  /**
   * ダイアログを閉じる
   * */
  closeDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.message = null;
    this.setState(state);
  };

  /**
   * 編集をやめるダイアログを表示する
   * */
  showCancelEditDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.cancelEditDialogEnabled.id;
    this.setState(state);
  };

  /**
   * ページを移動する旨を示すダイアログを表示する
   * */
  showLeaveThisPageDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.leaveThisPageDialogEnabled.id;
    this.setState(state);
  };

  /**
   * CCUS情報をすべて転記することに同意するかを確認するダイアログを表示する
   * */
  showCcusInfoTranscriptionAgreementDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus =
      DIALOG_STATUS.ccusInfoTranscriptionAgreementDialogEnabled.id;
    this.setState(state);
  };

  /**
   * CCUS情報をすべて転記することに同意するかを確認するダイアログを閉じる
   * */
  closeCcusInfoTranscriptionAgreementDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    this.setState(state, () => this.setCCUSValuesDetailAll());
  };

  /**
   * =====================================================
   * ダイアログ周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * API周りの処理 - START
   * =====================================================
   */

  /**
   * 更新を実行する前に実行する処理
   * バリデーションチェックと、要入力ダイアログ表示
   */
  handlerUpdate = () => {
    if (this.validateAll() === false) {
      return;
    }

    const resultValidate = this.validateAllSafetyDocItem();
    if (resultValidate.status === true) {
      this.updateWorkerSafetyBasicInfo();
      return;
    }

    const state = this.getStateWithConvertedDate();
    state.dialogStatus = DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id;
    state.confirmationModalSafetyDocItem.errorPropertyList = [];
    for (let key of Object.keys(resultValidate.messages)) {
      const constName = Object.values(
        SAFETY_DOC_ITEM_VALIDATE.WORKER_SAFETY_BASIC_INFO
      ).find(constValue => constValue.KEY === key);
      if (!_.isUndefined(constName)) {
        state.confirmationModalSafetyDocItem.errorPropertyList.push(
          constName.TEXT
        );
      } else {
        throw new Error(
          'WorkerSafetyBasicInfo.jsx handlerUpdate message property'
        );
      }
    }
    this.setState(state);
  };

  getStateWithConvertedDate = () => {
    const state = _.cloneDeep(this.state);
    state.workerSafetyBasicInfo.employer_in_date = convertDate(
      state.workerSafetyBasicInfo.employer_in_date
    );
    state.workerSafetyBasicInfo.employment_education_date = convertDate(
      state.workerSafetyBasicInfo.employment_education_date
    );
    state.workerSafetyBasicInfo.experience_start_date = convertDate(
      state.workerSafetyBasicInfo.experience_start_date
    );
    state.workerSafetyBasicInfo.staying_period_expiration_date = convertDate(
      state.workerSafetyBasicInfo.staying_period_expiration_date
    );
    return state;
  };

  /**
   * 作業者（労務安全基本情報）を更新する
   */
  updateWorkerSafetyBasicInfo = () => {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const state = this.getStateWithConvertedDate();
    workerSafetyBasicInfoApi
      .updateWorkerSafetyBasicInfo(this.props.companyId, this.props.workerId, {
        worker_details: state.workerSafetyBasicInfo,
        worker_documents: state.attachDocuments_Certificate,
      })
      .then(response => {
        if (response.result === true) {
          this.updatingFlag = false;
          this.moveToWorkerConfirm();
          return;
        }

        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        state.informationModal.message = extractErrorMessage(response);
        this.updatingFlag = false;
        this.setState(state);
      })
      .catch(error => {
        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        state.informationModal.message = extractErrorMessage(error);
        this.updatingFlag = false;
        this.setState(state);
      });
  };

  /**
   * =====================================================
   * API周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * フォーム周りの処理 - START
   * =====================================================
   */

  /**
   * バリデーション
   */
  validateAll = () => {
    const stateValue = _.cloneDeep(this.state);

    const result = validationByJoi(
      Joi.object().keys(workerSafetyBasicInfoService.createValidateSchema()),
      this.state.workerSafetyBasicInfo
    );

    if (result.status === false) {
      stateValue.validErrorMessage = {
        ..._.cloneDeep(this.state.validErrorMessage),
        ...result.messages,
      };
    } else {
      stateValue.validErrorMessage = {};
    }

    stateValue.validErrorMessage.attachDocuments_Certificate = attachDocumentFilesCheck(
      stateValue.attachDocuments_Certificate
    )
      ? ''
      : '添付ファイルエラー';

    this.setState(stateValue);

    return (
      Object.values(stateValue.validErrorMessage).filter(v => v !== '')
        .length === 0
    );
  };

  validate = keyName => {
    // console.log('WorkerSafetyBasicInfo.jsx validate', keyName);
    if (!parts.matchSome(keyName, this.validationColumns)) {
      throw new Error('WorkerSafetyBasicInfo.jsx validate');
    }

    const result = validationByJoi(
      Joi.object().keys(workerSafetyBasicInfoService.createValidateSchema()),
      this.state.workerSafetyBasicInfo
    );

    // 個別でバリデート
    const validErrorMessage = _.cloneDeep(this.state.validErrorMessage);
    if (_.has(result.messages, keyName)) {
      /**
       * TODO BLDE_V2-24753
       * numberバリデーションを設定した場合バリデーションメッセージが’必須です。’となる不具合がある
       * そのため暫定でメッセージを補正する処理を追加
       * BLDE_V2-24753 でバリデーションの不具合を解消する際にこちらのメッセージ補正処理を削除する
       * */
      if (keyName === 'blank_months') {
        validErrorMessage[keyName] = '0以上の数字を入力してください。';
      } else {
        validErrorMessage[keyName] = result.messages[keyName];
      }
    } else {
      validErrorMessage[keyName] = '';
    }

    this.setState({ validErrorMessage });
  };

  /**
   * 安全書類項目用バリデーション(要入力)
   */
  validateAllSafetyDocItem = () => {
    const state = this.getStateWithConvertedDate();
    const schema = workerSafetyBasicInfoService.createValidateSchemaSafetyDocItem(
      state.workerSafetyBasicInfo
    );

    const result = validationByJoi(
      Joi.object().keys(schema),
      state.workerSafetyBasicInfo
    );

    if (!parts.inProperty(result, 'messages,status')) {
      throw new Error('WorkerSafetyBasicInfo.jsx validateAllSafetyDocItem');
    }
    if (!_.isObject(result.messages)) {
      throw new Error('WorkerSafetyBasicInfo.jsx validateAllSafetyDocItem');
    }
    return result;
  };

  /**
   * 各種値の変更イベント
   */
  setValueWorkerSafetyBasicInfo(name, value) {
    value = deleteControlCode(value);
    const workerSafetyBasicInfo = _.cloneDeep(this.state.workerSafetyBasicInfo);
    const validErrorMessage = _.cloneDeep(this.state.validErrorMessage);
    workerSafetyBasicInfo[name] = value;

    if (name === 'foreigner_flag') {
      // 国籍の変更時に国名,在留資格,在留期間満了日をクリアする
      workerSafetyBasicInfo.nationality = null;
      workerSafetyBasicInfo.resident_status = 0;
      workerSafetyBasicInfo.resident_status_name = '未設定';
      workerSafetyBasicInfo.staying_period_expiration_date = null;
      delete validErrorMessage.resident_status;
      delete validErrorMessage.staying_period_expiration_date;
    }

    if (name === 'education') {
      if (value === '0') {
        workerSafetyBasicInfo.employment_education_date = null;
        delete validErrorMessage.employment_education_date;
      }
      if (value === '1') {
        workerSafetyBasicInfo.employment_education_date = moment().format(
          DATE_TIME_FORMAT.slashDateFormat
        );
      }
    }

    if (name === 'blood_type') {
      if (value === BLOOD_TYPE.UNKNOWN.ID) {
        // 血液型が『不明』の場合RH血液型も『不明』をセットする
        workerSafetyBasicInfo.blood_type_rh = BLOOD_TYPE_RH.UNKNOWN.ID;
      } else if (isNullOrUndefinedOrEmptyStr(value)) {
        // 血液型は数値しか取り得ないため空文字等はnullに変換する（DBがnull許容のためnullなら問題ない）
        workerSafetyBasicInfo.blood_type = null;
      }
    }

    // RH血液型は数値しか取り得ないため空文字等はnullに変換する（DBがnull許容のためnullなら問題ない）
    if (name === 'blood_type_rh' && isNullOrUndefinedOrEmptyStr(value)) {
      workerSafetyBasicInfo.blood_type_rh = null;
    }

    this.setState({ workerSafetyBasicInfo, validErrorMessage });
  }

  /**
   * 在留資格 ComboBox 用イベント
   */
  setWorkerSafetyBasicInfoResidentStatus(code) {
    if (!_.isString(code)) {
      throw new Error(
        'WorkerSafetyBasicInfo.jsx setWorkerSafetyBasicInfoResidentStatus'
      );
    }
    const workerSafetyBasicInfo = _.cloneDeep(this.state.workerSafetyBasicInfo);
    const residentStatus = this.state.comboBoxList.residentStatus.find(
      item => item.resident_status_code === Number(code)
    );
    if (residentStatus) {
      workerSafetyBasicInfo.resident_status_name =
        residentStatus.resident_status_name;
    }
    workerSafetyBasicInfo.resident_status = Number(code);

    this.setState({ workerSafetyBasicInfo }, () => {
      this.validate('resident_status');
    });
  }

  /**
   * CCUS 入力ボタン処理（個別項目のCCUS転記の←矢印押下時）
   * @param {String} name: 転記したい項目のプロパティ名
   */
  setCCUSValuesDetail(name) {
    if (!_.isString(name)) {
      throw new Error('WorkerSafetyBasicInfo.jsx setCCUSValuesDetail');
    }

    const workerSafetyBasicInfo = _.cloneDeep(this.state.workerSafetyBasicInfo);
    const validErrorMessage = _.cloneDeep(this.state.validErrorMessage);

    let val;
    if (
      name === 'staying_period_expiration_date' ||
      name === 'experience_start_date'
    ) {
      val = moment(
        this.state.ccusInfo[name],
        DATE_TIME_FORMAT.hyphenDateFormat
      ).format(DATE_TIME_FORMAT.slashDateFormat);
    } else if (name === 'resident_status') {
      val = this.state.ccusInfo.resident_status_code;
    } else {
      val = _.cloneDeep(this.state.ccusInfo[name]);
    }

    workerSafetyBasicInfo[name] = val;

    // CCUS転記の場合、国籍＝日本国籍の場合はデータ消去する
    if (name === 'foreigner_flag') {
      if (val === NATIONALITY_INFO.JAPAN.ID) {
        workerSafetyBasicInfo.nationality = null;
        workerSafetyBasicInfo.resident_status = 0;
        workerSafetyBasicInfo.resident_status_name = '未設定';
        workerSafetyBasicInfo.staying_period_expiration_date = null;
        delete validErrorMessage.staying_period_expiration_date;
      }
    }

    if (name === 'blood_type' && val === BLOOD_TYPE.UNKNOWN.ID) {
      // 血液型が『不明』の場合RH血液型も『不明』をセットする
      workerSafetyBasicInfo.blood_type_rh = BLOOD_TYPE_RH.UNKNOWN.ID;
    }

    this.setState({ workerSafetyBasicInfo, validErrorMessage }, () => {
      if (parts.matchSome(name, this.validationColumns)) {
        this.validate(name);
      }
    });
  }

  /**
   * 「CCUS入力情報を全て転記」ボタン押下時の処理
   */
  setCCUSValuesDetailAll() {
    // CCUS入力項目が存在する項目のvalueのみコピー
    const workerSafetyBasicInfo = _.cloneDeep(this.state.workerSafetyBasicInfo);
    const validErrorMessage = _.cloneDeep(this.state.validErrorMessage);
    delete validErrorMessage.staying_period_expiration_date;

    _.map(this.state.ccusInfo, (targetValue, targetKey) => {
      if (isNullOrUndefinedOrEmptyStr(targetValue)) {
        return;
      }

      if (targetKey === 'staying_period_expiration_date') {
        if (
          workerSafetyBasicInfo.foreigner_flag === NATIONALITY_INFO.FOREIGN.ID
        ) {
          workerSafetyBasicInfo[targetKey] = moment(
            targetValue,
            DATE_TIME_FORMAT.hyphenDateFormat
          ).format(DATE_TIME_FORMAT.slashDateFormat);
        }
      } else if (targetKey === 'experience_start_date') {
        workerSafetyBasicInfo[targetKey] = moment(
          targetValue,
          DATE_TIME_FORMAT.hyphenDateFormat
        ).format(DATE_TIME_FORMAT.slashDateFormat);
      } else if (targetKey === 'resident_status_code') {
        workerSafetyBasicInfo.resident_status = this.state.ccusInfo.resident_status_code;
      } else if (targetKey === 'resident_status_name') {
        // 在留資格のデータは resident_status_code の方で処理されるので
        // ここでは処理を行わない
      } else if (targetKey === 'blood_type') {
        // 血液型がBuildeeで対応しているコードの場合のみ転記する
        const bloodType = getTextBloodTypeId(targetValue);
        if (!_.isNil(bloodType)) {
          workerSafetyBasicInfo[targetKey] = targetValue;
        }
      } else if (targetKey === 'foreigner_flag') {
        workerSafetyBasicInfo[targetKey] = targetValue;
        // CCUS転記の場合、国籍＝日本国籍の場合はデータ消去する
        if (targetValue === NATIONALITY_INFO.JAPAN.ID) {
          workerSafetyBasicInfo.nationality = null;
          workerSafetyBasicInfo.resident_status = 0;
          workerSafetyBasicInfo.resident_status_name = '未設定';
          workerSafetyBasicInfo.staying_period_expiration_date = null;
          delete validErrorMessage.staying_period_expiration_date;
        }
      } else {
        workerSafetyBasicInfo[targetKey] = targetValue;
      }

      if (targetKey === 'blood_type' && targetValue === BLOOD_TYPE.UNKNOWN.ID) {
        // 血液型が『不明』の場合RH血液型も『不明』をセットする
        workerSafetyBasicInfo.blood_type_rh = BLOOD_TYPE_RH.UNKNOWN.ID;
      }
    });

    this.setState({ workerSafetyBasicInfo, validErrorMessage }, () => {
      this.validateAll();
    });
  }

  /**
   * 添付書類 ファイル選択処理
   */
  uploadFile = async (file, typeL, typeS) => {
    attachDocumentWorkerUploadState(
      this.state.attachDocuments_Certificate,
      documents => {
        this.setState({ attachDocuments_Certificate: documents }, () => {
          this.validateAll();
        });
      },
      this.props.companyId,
      this.props.workerId,
      file,
      typeL,
      typeS
    );
  };

  /**
   * 添付書類 ファイルダウンロード処理
   */
  async download(fileId) {
    await attachDocumentWorkerDownload(
      () => {
        this.setState({
          dialogStatus: DIALOG_STATUS.attachFileNotExistDialogEnagled.id,
        });
      },
      this.props.companyId,
      this.props.workerId,
      fileId
    );
  }

  /**
   * 添付書類 ファイル登録削除処理
   */
  deleteFile = file => {
    attachDocumentDeleteState(
      this.state.attachDocuments_Certificate,
      documents => {
        this.setState({ attachDocuments_Certificate: documents }, () => {
          this.validateAll();
        });
      },
      file
    );
  };

  /**
   * データ内で雇入時教育受講有無などが未設定の場合初期値設定する
   */
  setDefaultFormValues = (key, value, formValues) => {
    const newFormValues = _.cloneDeep(formValues);
    switch (key) {
      case 'education': // 雇入時教育受講有無
      case 'ability_improving_education_code': // 能力向上教育受講有無
        if (isNullOrUndefinedOrEmptyStr(value)) {
          newFormValues[key] = '0'; // 「無」に設定
        }
        break;
      default:
        break;
    }
    return newFormValues;
  };

  /**
   * =====================================================
   * フォーム周りの処理 - END
   * =====================================================
   */

  /**
   * CCUSから情報を取得するボタン・補足説明の表示
   */
  showFetchCcusDescription = () => {
    const REACT_APP_ZENDESK_URL = ENV_VARS.REACT_APP_ZENDESK_URL;
    if (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID) {
      if (this.props.isAgencyRegister) {
        if (!_.has(this.props.agencyInfo, 'in_upstream_ccus_field_trees')) {
          // 上下関係取得前は何も表示しない（画面の初表示など）
          return;
        } else {
          // 代行先の作業員
          const canFetchCcus =
            this.props.isAlreadyCcusConnect &&
            this.props.agencyInfo.in_upstream_ccus_field_trees &&
            this.props.isLinkedUser;
          // BLDE_V2-50226 CCUS事業者IDは削除された場合に転記情報は表示されない
          if (canFetchCcus && !this.props.isCcusJigyousyaDeleted) {
            if (isNullOrUndefinedOrEmptyStr(this.props.linkedToCcusDate)) {
              return (
                <FetchCcusDescription
                  description={messageUtility.getMessage('I-000-161')}
                  onClick={() => this.props.callFetchCcusWorkersData()}
                />
              );
            } else {
              return (
                <FetchCcusDescription
                  description={messageUtility.getMessage('I-000-162')}
                  linkedToCcusDate={this.props.linkedToCcusDate}
                  onClick={() => this.props.callFetchCcusWorkersData()}
                />
              );
            }
          } else {
            return (
              // 代行先のCCUSに登録された詳細情報はCCUSの制限により取得できません。<br>Buildeeに直接入力を行ってください。
              <FetchCcusDescription
                description={
                  <span>
                    CCUSから情報を取得することができません。赤字の条件が満たされていません。
                    <br />
                    CCUSから代行先の情報を取得するには、下記の条件をすべて満たす必要があります。
                    <br />
                    <br />
                    <ul className='fetch-ccus-description-message__text-list'>
                      {/* BLDE_V2-50226 CCUS事業者IDは削除された場合に文言は赤色になる */}
                      {/* BLDE_V2-50623 代行先会社はCCUSと連携されているかどうかによって文言の色は変更する */}
                      <li
                        className={
                          this.props.isCcusJigyousyaConnected &&
                          this.props.isAlreadyCcusConnect &&
                          !this.props.isCcusJigyousyaDeleted
                            ? ''
                            : 'text--negative'
                        }
                      >
                        <span className='fetch-ccus-description-message__text'>
                          {messageUtility.getMessage('I-000-263')}
                        </span>
                      </li>
                      <li
                        className={
                          this.props.isLinkedUser ? '' : 'text--negative'
                        }
                      >
                        <span className='fetch-ccus-description-message__text'>
                          あなたのアカウントが代行先の連携ユーザーとして設定されている
                        </span>
                        {!this.props.isLinkedUser && (
                          <span>
                            （
                            <span
                              className='clickable-text'
                              onClick={() => {
                                masterSlideLoader.show('PrimeCcusPreview', {
                                  state: { id: this.props.companyId },
                                });
                              }}
                            >
                              こちら
                            </span>
                            から設定してください）
                          </span>
                        )}
                      </li>
                      <li
                        className={
                          this.props.agencyInfo.in_upstream_ccus_field_trees
                            ? ''
                            : 'text--negative'
                        }
                      >
                        <span className='fetch-ccus-description-message__text'>
                          施工体制のCCUS連携を行っているいずれかの現場で、代行先の会社があなたの会社の下位協力会社として登録されている
                        </span>
                        {!this.props.agencyInfo
                          .in_upstream_ccus_field_trees && (
                          <span>
                            （詳細は
                            <a
                              className='clickable-text'
                              href={`${getZendeskArticleUrl(
                                REACT_APP_ZENDESK_URL,
                                ZENDESK_LINK_IDS.CCUS_FIELD_TREES
                              )}`}
                              target='_blank'
                              rel='noopener noreferrer'
                            >
                              こちら
                            </a>
                            をご確認ください。）
                          </span>
                        )}
                      </li>
                    </ul>
                  </span>
                }
                disabledCcusConnectionButton
              />
            );
          }
        }
      }
      // BLDE_V2-50226 CCUS事業者IDは削除された場合に転記情報は表示されない
      if (
        (this.props.isAlreadyCcusConnect &&
          this.props.isCcusJigyousyaDeleted) ||
        !this.props.isCcusJigyousyaConnected
      ) {
        return null;
      }
      if (
        !this.props.isLinkedUser ||
        !this.props.ccusEngineerId ||
        !this.props.isAlreadyCcusConnect
      ) {
        return (
          <FetchCcusDescription
            disabledCcusConnectionButton
            description={
              <div>
                <p>
                  CCUSから情報を取得することができません。赤字の条件が満たされていません。
                </p>
                <p>
                  CCUSから情報を取得するには、下記の条件をすべて満たす必要があります。
                </p>
                <ul className='fetch-ccus-description-message__text-list'>
                  <li
                    className={!this.props.isLinkedUser ? 'text--negative' : ''}
                  >
                    <span className='fetch-ccus-description-message__text'>
                      あなたのアカウントが自社の連携ユーザーとして設定されている
                    </span>
                    {!this.props.isLinkedUser && (
                      <span>
                      （
                      <span
                        className='clickable-text'
                        onClick={() => {
                          masterSlideLoader.show('PrimeCcusPreview', {
                            state: { id: this.props.companyId },
                          });
                        }}
                      >
                        こちら
                      </span>
                        から設定してください）
                      </span>
                    )}
                  </li>
                  <li
                    className={
                      !this.props.ccusEngineerId ||
                      !this.props.isAlreadyCcusConnect
                        ? 'text--negative'
                        : ''
                    }
                  >
                    <span className='fetch-ccus-description-message__text'>
                      作業員の基本情報タブにCCUS技能者IDが登録されておりCCUS連携に成功している
                    </span>
                  </li>
                </ul>
                <br />
                <p>
                  作業員のCCUS連携の手順は
                  <a
                    className='clickable-text'
                    href={ZENDESK_URL_GUIDE.CCUS_WORKER_WARNING}
                    target='_blank'
                    rel='noreferrer noopener'
                  >
                    こちら
                  </a>
                  をご確認ください。
                </p>
              </div>
            }
          />
        );
      }
      if (isNullOrUndefinedOrEmptyStr(this.props.linkedToCcusDate)) {
        return (
          <FetchCcusDescription
            description={messageUtility.getMessage('I-000-161')}
            onClick={() => this.props.callFetchCcusWorkersData()}
          />
        );
      } else {
        return (
          <FetchCcusDescription
            description={messageUtility.getMessage('I-000-162')}
            linkedToCcusDate={this.props.linkedToCcusDate}
            onClick={() => this.props.callFetchCcusWorkersData()}
          />
        );
      }
    }
  };

  // 画面表示
  render() {
    return (
      <React.Fragment>
        <WorkerHeader
          LinkButtonObject={this.state.header.LinkButtonObject}
          buttonObject={this.state.header.buttonObject}
          errorMessagesCount={
            Object.values(this.state.validErrorMessage).filter(v => v !== '')
              .length
          }
        />
        <div className='contruction-detail-view__bar' />

        <WorkerSafetyBasicInfoForm
          ccusDescription={this.showFetchCcusDescription()} /* CCUSから情報を取得するボタン・補足説明 */
          events={this.events}
          formValues={{
            workerSafetyBasicInfo: this.state.workerSafetyBasicInfo,
            ccus_info: this.state.ccusInfo,
          }}
          messages={this.state.validErrorMessage}
          comboBoxList={this.state.comboBoxList}
          disabledAll={this.props.pageStatus.DISABLED_ALL}
          isOverSixteen={this.props.isOverSixteen}
          attachDocument={this.state.attachDocument}
          attachDocumentCodes_Certificate={
            this.state.attachDocumentCodes_Certificate
          }
          attachDocuments_Certificate={this.state.attachDocuments_Certificate}
          isCcusJigyousyaDeleted={this.props.isCcusJigyousyaDeleted} // BLDE_V2-50226 CCUS事業者IDは削除されたかどうか決断
        />

        {/* 更新失敗時のダイアログ */}
        <Information
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.updateFailedDialogEnabled.id
          }
          title={messageUtility.getMessage('E-000-005')}
          message={this.state.informationModal.message}
          buttonText={messageUtility.getMessage('I-000-008')}
          onClose={() => this.closeDialog()}
        />

        {/* 編集をやめる時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus === DIALOG_STATUS.cancelEditDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-025')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-050')}
          isNegative
          onConfirm={() => this.moveToWorkerConfirm()}
          onCancel={() => this.closeDialog()}
        />

        {/* 作業員一覧へ戻る時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.leaveThisPageDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-051')}
          confirmButtonText={messageUtility.getMessage('I-000-053')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-052')}
          isNegative
          onConfirm={() => this.moveToWorkerList()}
          onCancel={() => this.closeDialog()}
        />

        {/* CCUS全て転記ダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.ccusInfoTranscriptionAgreementDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-164')}
          confirmButtonText={messageUtility.getMessage('I-000-165')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={
            <React.Fragment>
              {messageUtility.getMessage('I-000-166')}
              <MoveLeftIcon className='form-list__element-ccus-icon' />
              {messageUtility.getMessage('I-000-167')}
            </React.Fragment>
          }
          isNegative
          negativeButtonClassName='btn'
          rootClassName={styles.CcusInfoTranscriptionAgreementDialog}
          onConfirm={() => this.closeCcusInfoTranscriptionAgreementDialog()}
          onCancel={() => this.closeDialog()}
        />

        {/* 安全書類項目確認のダイアログ */}
        <ConfirmationSafetyDocItemDialog
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id
          }
          errorPropertyList={
            this.state.confirmationModalSafetyDocItem.errorPropertyList
          }
          onConfirm={() => {
            if (this.validateAll() !== true) {
              throw new Error('Confirmation safetyDocItemErrorDialogEnabled');
              // ダイアログが開いている場合に
              // 通常バリデートがエラーになっている場合はない想定をしている
            }
            this.updateWorkerSafetyBasicInfo();
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id });
          }}
          onCancel={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id });
          }}
        />

        {/* 添付ファイルが存在しないときのエラー表示 */}
        <Information
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.attachFileNotExistDialogEnagled.id
          }
          title={
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <i
                className='icon-error'
                style={{
                  fontSize: 24,
                  color: 'red',
                }}
              />
              <p>エラーが発生しました。</p>
            </div>
          }
          message={'指定されたファイルが存在しません。'}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id });
          }}
        />
      </React.Fragment>
    );
  }
}

// 定数
const data = {
  buttonLink: {
    label: '作業員一覧',
    defaultClassName: 'btn-text--sm',
  },
  defaultButton: {
    label: '',
    className: 'btn',
  },
  header: {
    confirm: {
      button: {
        edit: {
          label: '編集',
          className: 'btn',
        },
      },
    },
    edit: {
      button: {
        cancel: {
          label: '編集をやめる',
          className: 'btn--sub',
        },
        update: {
          label: '更新',
          className: 'btn--effective',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/worker/page/WorkerSafetyBasicInfo.jsx